import * as React from "react";
import { AppMode, DataEntryComponentProps, TemplateData } from "../types";
import { RunningTemplateContext } from "../context/runningTemplate";
import { componentHasValue } from "../utils/componentUtils";
import AppModeContext from "../context/appMode";
import { ComponentAssociatedTextEdit, ComponentAssociatedTextView } from "./componentAssociatedTextOptions";

type ComponentAssociatedTextProps = DataEntryComponentProps & {
    text?: string;
    getComponentHasValue?: (templateData: TemplateData) => boolean;
    onTextChange?: (text: string) => void;
};

const ComponentAssociatedText = (props: ComponentAssociatedTextProps) => {
    const { templateData = {} } = React.useContext(RunningTemplateContext);
    const { mode } = React.useContext(AppModeContext);

    const {
        hasAssociatedText,
        associatedText,
        isSelected,
        onSelect,
        id,
        type,
        onPropertyUpdate,
        getComponentHasValue,
    } = props;
    const isInRunMode = mode === AppMode.RUN;
    const isRunModeAssociatedTextAvailable = () =>
        hasAssociatedText &&
        (typeof getComponentHasValue !== "undefined"
            ? getComponentHasValue(templateData)
            : componentHasValue(templateData, id, type));

    const isAvailable = isInRunMode ? isRunModeAssociatedTextAvailable() : hasAssociatedText;
    if (!isAvailable) {
        return null;
    }

    const content = () => {
        switch (mode) {
            case AppMode.EDIT:
                return (
                    <ComponentAssociatedTextEdit
                        associatedText={associatedText}
                        isSelected={isSelected}
                        onSelect={onSelect}
                        onPropertyUpdate={onPropertyUpdate}
                    />
                );
            case AppMode.READ:
                return <ComponentAssociatedTextView associatedText={associatedText} />;
            default:
                return null;
        }
    };

    return <div className="canvas-item-entry">{content()}</div>;
};

export default ComponentAssociatedText;
